import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedAnnotationIds } from '../app/interface';
import { annotationsApi, deleteAnnotations } from '../app/annotations.js'
import { deleteTextAnnotations, selectTextAnnotations } from '../app/textAnnotations.js'
import { selectMultipleAnnotations } from '../app/interface.js'
import { selectCurrentUserId } from '../app/auth';
import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

const DeleteConfirmationModal = ({open, setDeleteConfirmOpen, annotation_count, itemName = "annotation" }) => {

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const inspectionId = searchParams.get("inspectionId")
  const currentUserId = useSelector(selectCurrentUserId)
  const selectedAnnotationsIds = useSelector(selectSelectedAnnotationIds)
  const textAnnotations = useSelector(selectTextAnnotations)
  const [modalCheck, setModalCheck] = useState(null) // used to handle mount triggering once

  // handles listeners
  useEffect(() => {
    if (modalCheck !== null) {
      if (open) {
        window.addEventListener('keyup', handleModalKeyUp);
      } else {
        window.removeEventListener('keyup', handleModalKeyUp);
      }
    } else {
      // component is mounting we don't trigger or remove listeners
      setModalCheck(true)
    }
    // Clean listeners on unmount
    return () => {
      window.removeEventListener('keyup', handleModalKeyUp);
    };
  }, [open]);

  const handleDelete = () => {
    // list ids
    const ids = selectedAnnotationsIds
    annotationsApi.delete({ids: ids, inspectionId: inspectionId, userId: currentUserId},
    (res) => {
      // close delete confirmation modal
      setDeleteConfirmOpen(false)
      if (res === true){
        // remove id from selection
        dispatch(selectMultipleAnnotations([]))
        const textIds = textAnnotations.filter((a) => ids.includes(a.id)).map((a) => a.id)
        if (textIds.length > 0) {
          dispatch(deleteTextAnnotations({ ids: textIds }))
        }
        const annotationIds = ids.filter((id) => !textIds.includes(id))
        if (annotationIds.length > 0) {
          // remove annotation from elements
          dispatch(deleteAnnotations({ids: annotationIds}))
        }
      }
    })
  }

  // using callback to ensure listner tracking
  const handleModalKeyUp = useCallback((e) => {
    if (e.key === 'Backspace'|| e.key === 'Delete') {
      handleDelete();
      setDeleteConfirmOpen(false);
    }
  }, [handleDelete, setDeleteConfirmOpen]);
          
  return (
    <Dialog open={open} onClose={() => {
      setDeleteConfirmOpen(false)
    }}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <p>Are you sure you want to delete {annotation_count > 1 ? "these " + annotation_count + " " + itemName + "s" : "this " + itemName}?</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setDeleteConfirmOpen(false)
        }} color="primary">Cancel</Button>
        <Button onClick={handleDelete} color="error">Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;